import rulesReducer from './payment-orchestration-rules.slice';
import sourcesReducer from './orchestration-rules-sources.slice';
import dynamicRulesReducer from './payment-orchestration-dynamic-rules.slice';

const { combineReducers } = require('@reduxjs/toolkit');

const paymentOrchestrationReducer = combineReducers({
  rules: rulesReducer,
  sources: sourcesReducer,
  dynamicRules: dynamicRulesReducer,
});

export default paymentOrchestrationReducer;
